const pastepal = {
    name: 'PastePal',
    slug: 'pastepal',
    keywords: ['macos', 'ios', 'iphone', 'ipad', 'clipboard', 'pasteboard', 'native', 'universal'],
    header: {
        background: '#5488E5',
        twitter: 'PastePalApp'
    },
    headline: {
        title: 'Your next favorite \npasteboard manager',
        text: 'PastePal is the best universal pasteboard manager for Mac, iPhone and iPad.',
        imageUrl: 'https://user-images.githubusercontent.com/2284279/104728857-d303ee00-5737-11eb-886b-412c767f04a6.png',
    },
    download: {
        appstore: [
            {
                id: 'id1503446680',
                platform: 'macOS',
                version: '11.0'
            },
            {
                id: 'id1503446680',
                platform: 'iOS',
                version: '14.0'
            }
        ]
    },
    productHunt: {
        link: 'https://www.producthunt.com/posts/pastepal-2-0',
        id: '281612'
    },
    blocks: [
        {
            style: 'g1',
            items: [
                {
                    title: 'Native',
                    subtitle: 'Written in pure Swift and truly native to embrace the Mac experience. Built exclusively for Big Sur.',
                    icon: 'file_54'
                },
                {
                    title: 'Universal',
                    subtitle: 'Universal purchase. Support Mac, iPhone and iPad apps. Sync with iCloud across all your devices.',
                    icon: 'mac_mobile'
                },
                {
                    title: 'No subscription',
                    subtitle: 'No recurring subscription. Buy once, use forever. Even for future updates.',
                    icon: 'shopping_2'
                },
                {
                    title: 'No tracking',
                    subtitle: 'No analysis and data collecting. Your data remain locally and safe on your devices.',
                    icon: 'sport_12'
                },
                {
                    title: 'Under your control',
                    subtitle: 'Organize pasteboard history the way you want. Specify what and how the history is saved with various settings in the app.',
                    icon: 'ui_4'
                },
                {
                    title: 'Fast',
                    subtitle: 'Unlimited history with blazing fast index and search.',
                    icon: 'eco_29'
                }
            ]
        },
        {
            style: 'y1',
            youtubeId: 'UmsqhXUO5oc'
        },       
        {
            style: 's1',
            title: 'Flexible bar',
            subtitle: 'Access your most recent history at easy with a flexible and unobtrusive bar. Position it wherever you want, either top, left, bottom or right edge of the screen.',
        },
        {
            style: 'i1',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/104813574-45450300-580a-11eb-8fcb-d6e71f9c9428.png'
        },
        {
            style: 'g1',
            items: [
                {
                    title: 'Position',
                    subtitle: 'Place it either top, left, bottom or right edge of the screen. You can setup keyboard shortcuts to show and change position.',
                    icon: 'desktop_13'
                },
                {
                    title: 'Smart detection',
                    subtitle: 'Smart detection of copied and pasted item together with its source application',
                    icon: 'machine_3'
                },
                {
                    title: 'Context menu',
                    subtitle: 'Right click on any history item to access powerful context menu. Copy, delete, add to collection, share, and more.',
                    icon: 'shopping_28'
                },
                {
                    title: 'Preview',
                    subtitle: 'View raw and quick look content withh convenient popover.',
                    icon: 'ui_17'
                },
                {
                    title: 'Drag and Drop',
                    subtitle: 'Drag one or multiple files, even your newly captured screenshot.',
                    icon: 'sport_25'
                },
                {
                    title: 'Descriptive',
                    subtitle: 'At a glance, know content type, application, collection, date, how many chracters of each history item.',
                    icon: 'travel_33'
                },
                {
                    title: 'Unobtrusive',
                    subtitle: 'Show with keyboard shortcut or from menu bar. Dismiss with Esc key or the down arrow button.',
                    icon: 'design_11'
                },
                {
                    title: 'Unpin',
                    subtitle: 'During unpin, touch anywhere outside side window to dismiss it.',
                    icon: 'sport_2'
                }
            ]
        },
        {
            style: 's1',
            title: 'Omniscient main view',
            subtitle: 'Filter and search all your history by app, content type, collections.',
        },
        {
            style: 'h1',
            title: 'Organize and filter',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/104784942-abd60c80-5789-11eb-93d7-b1dfa5e893b7.png',
            items: [
                {
                    title: 'Adaptive grid',
                    subtitle: 'Automatic resizing grid with adaptive layout.',
                    icon: 'furniture_5'
                },
                {
                    title: 'Quick grouping',
                    subtitle: 'Select items by source applications, recognized content type or make your own collections.',
                    icon: 'drink_61'
                },
                {
                    title: 'Search and pagination',
                    subtitle: 'History is paginated for better performance. Use search field at the bottom toolbar to find more.',
                    icon: 'design_16'
                },
                {
                    title: 'Dark mode',
                    subtitle: 'Gorgeous light and dark mode themes.',
                    icon: 'weather_6'
                }
            ]
        },
        {
            style: 'h2',
            title: 'Powerful settings',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/104832549-1e321400-5892-11eb-9376-7e9b2d083590.png',
            items: [
                {
                    title: 'Fine tune history',
                    subtitle: 'Quick toggle to pause and resume pasteboard observation. Control how long your data is preserved.',
                    icon: 'time_7'
                },
                {
                    title: 'Allow and Ignore list',
                    subtitle: 'Specify which app, content or folder is allowed or ignored.',
                    icon: 'travel_5'
                },
                {
                    title: 'Privacy',
                    subtitle: 'Control whether to save passwords and sensitive data.',
                    icon: 'eco_25'
                },
                {
                    title: 'Keyboard shortcuts',
                    subtitle: 'Setup your own keyboard shortcuts to maximize productivity. Toggle flexible bar, copy, delete, esc and more.',
                    icon: 'ui_6'
                }
            ]
        },
        {
            style: 's1',
            title: 'Smart content type',
            subtitle: 'Recognize common content types and group them for easy access.',
        },
        {
            style: 'g1',
            items: [
                {
                    title: 'Text',
                    subtitle: 'Show how many characters and lines for recognized text strings. Preview as Raw.',
                    icon: 'design_9'
                },
                {
                    title: 'Rich Text',
                    subtitle: 'Rich formatted texts including code snippets. Preview as Rich Text.',
                    icon: 'design_8'
                },
                {
                    title: 'Hex Color',
                    subtitle: 'Detect hex color format like #AABBCC and preview them inline.',
                    icon: 'design_14'
                },
                {
                    title: 'Emoji',
                    subtitle: 'Emoji is special. Show it in full scale.',
                    icon: 'emotion_45'
                },
                {
                    title: 'Link',
                    subtitle: 'Show primary thumbnail and page title of a link. Preview as inline browser.',
                    icon: 'design_19'
                },
                {
                    title: 'Image',
                    subtitle: 'Image copied from browser or drawing applications. Preview as original size.',
                    icon: 'drink_2'
                },
                {
                    title: 'PDF',
                    subtitle: 'Specify treatment for PDF file. Preview as interactable PDF.',
                    icon: 'file_pdf'
                },
                {
                    title: 'File',
                    subtitle: 'Show file path and size of copied file. Preview Quick Look representation.',
                    icon: 'file_27'
                },
                {
                    title: 'Multiple Files',
                    subtitle: 'Save multiple files as Quick Look and with locations. Preview multiple paths.',
                    icon: 'file_32'
                }
            ]
        },
        {
            style: 's1',
            title: 'Convenient iPhone app',
            subtitle: 'Still powerful but crafted exclusively for mobile experience',
        },
        {
            style: 'i1',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/104855493-6a6e6a00-590d-11eb-9e02-cecf9bea1b19.png'
        },
        {
            style: 'g1',
            items: [
                {
                    title: 'Privacy',
                    subtitle: 'Honor iOS 14 pasteboard privacy policy. No automatic pasteboard observation, but you can manually insert item into history.',
                    icon: 'desktop_5'
                },
                {
                    title: 'Smart content type',
                    subtitle: 'Recognize common content types like text, link, emoji and hex colors. More will be supported.',
                    icon: 'design_8'
                },
                {
                    title: 'iCloud Sync',
                    subtitle: 'By default, sync is disabled so you can use like separate apps. But iCloud Sync can be enabled in Settings.',
                    icon: 'weather_13'
                },
                {
                    title: 'Share sheet extension',
                    subtitle: 'Share any text content easily to PastePal.',
                    icon: 'eco_11'
                },
                {
                    title: 'Fabulous icons',
                    subtitle: 'Choose from well crafted alternate app icons',
                    icon: 'eco_3'
                },
                {
                    title: 'Dark mode',
                    subtitle: 'Gorgeous light and dark mode themes.',
                    icon: 'weather_6'
                }
            ]
        },
        {
            style: 's1',
            title: 'Look great on iPad',
            subtitle: 'The same Mac experience you used to love, with gorgeous sidebar and grid view.',
        },
        {
            style: 'h2',
            title: '',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/104853402-e57d5380-5900-11eb-9edd-88234924c77f.png',
            items: [
                {
                    title: 'Context menu',
                    subtitle: 'Force touch on any history item to access powerful context menu. Copy, delete, add to collection, share, and more.',
                    icon: 'shopping_28'
                },
                {
                    title: 'Any screen orientation',
                    subtitle: 'Adapative layout for both landscape and portrait mode.',
                    icon: 'desktop_9'
                },
                {
                    title: 'Dark mode',
                    subtitle: 'Gorgeous light and dark mode themes.',
                    icon: 'weather_6'
                }
            ]
        },
    ],
    showcase: {
        platforms: ['macOS', 'iOS'],
        background: '#448FED',
        tagline: 'Smart pasteboard manager for Mac',
        detail: true,
        pressKit: {
            url: 'https://drive.google.com/drive/folders/10EOy47u30RAx6zrLdY_K9RfooqJwXaTU?usp=sharing'
        }
    }
}

export default pastepal